import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import './UserType.css';
import Select from "react-select";
import { AuthContext } from '../../context/AuthContext';
import useUser from '../../context/hooks/useUser';

import { TipoDespesasVendedorContext } from '../../context/TipoDespesasVendedorContext';
import { TipoDespesasVendedorType, UpdateTipoDespesasVendedorType } from '../../context/hooks/useTipoDespesasVendedor';

import { CreateTipoDespesasVendedorModal } from '../../components/TipoDespesasVendedor/CreateTipoDespesasVendedorModal';
import { EditTipoDespesasVendedorModal } from '../../components/TipoDespesasVendedor/EditDespesasVendedorModal';

const ContaPagar = () => {
    const { objUserTk } = useContext(AuthContext);
    const { listTipoDespesasVendedor, tipoDespesasVendedorPageCount, getAllTipoDespesasVendedorPaged, deleteTipoDespesasVendedor } = useContext(TipoDespesasVendedorContext);
    const { getPermissionsByUser, userPermissions } = useUser();
    const [editingTipoDespesasVendedor, setEditingTipoDespesasVendedor] = useState<UpdateTipoDespesasVendedorType | null>(null);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    const [loading, setLoading] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);

    const [filters, setFilters] = useState({
        name: '',
    });
    const [dataSearch, setDataSearch] = useState({ name: '' });

    useEffect(() => {
        setLoading(true);

        getAllTipoDespesasVendedorPaged(1, 9, objUserTk.EmpresaId)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar tipos de despesas:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getAllTipoDespesasVendedorPaged(value, 9, objUserTk.EmpresaId);
    };

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = () => {
        setLoading(true);
        getAllTipoDespesasVendedorPaged(1, 9, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao aplicar filtros:", error);
                setLoading(false);
            });
    };

    const handleClearFilters = () => {
        setFilters({ name: '' });
        setLoading(true);
        getAllTipoDespesasVendedorPaged(1, 9, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao liimpar filtros:", error);
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleEditTipoDespesasVendedor = (tipoDespesasVendedor: TipoDespesasVendedorType) => {
        setEditingTipoDespesasVendedor(tipoDespesasVendedor);
        setEditModalOpen(true);
    };

    const handleDeleteTipoDespesasVendedor = (tipoDespesasVendedorId: number) => {
        if (window.confirm("Tem certeza que deseja excluir este tipo de despesa?")) {
            deleteTipoDespesasVendedor(tipoDespesasVendedorId)
                .then(deletedTipoDespesasVendedor => {
                    if (deletedTipoDespesasVendedor) {
                        getAllTipoDespesasVendedorPaged(1, 9, objUserTk.EmpresaId);
                    } else {
                        console.error("Erro ao excluir tipo de despesa.");
                    }
                    getAllTipoDespesasVendedorPaged(1, 9, objUserTk.EmpresaId);
                })
                .catch(error => {
                    console.error("Erro ao excluir tipo de despesa:", error);
                });
        }
    };

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Tipos de despesas"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">
                <Row className="align-items-center mb-4">
                    {/* <Col xs="12" md="9" lg="9" className="mb-2">
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="name"
                            id="name"
                            placeholder="Buscar por nome da categoria"
                            value={dataSearch.name}
                            onChange={handleFilterChange}
                        />
                    </Col>
                    <Col xs="12" md="3" lg="3" className="d-flex justify-content-start justify-content-md-end mb-2">
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#585858" }}
                            type="button"
                            size="m"
                            onClick={handleSearch}
                            className="mr-2"
                        >
                            Buscar
                        </Button>
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                            type="button"
                            size="m"
                            onClick={handleClearFilters}
                        >
                            Limpar
                        </Button>
                    </Col> */}

                    {userPermissions.includes(1) && (
                        <Col xs="12" className="text-right mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                className="btn-filter"
                                onClick={() => setCreateModalOpen(true)}
                            >
                                Adicionar tipo de despesas
                            </Button>
                        </Col>
                    )}
                </Row>

                {userPermissions.includes(2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped custom-table">
                                <thead>
                                    <tr>
                                        <th>Sequência</th>
                                        <th>Nome</th>
                                        <th>Ícone</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listTipoDespesasVendedor.map((tipoDespesasVendedor: TipoDespesasVendedorType, index: number) => {
                                        return (
                                            <tr key={index}>
                                                <td>{tipoDespesasVendedor.id}</td>
                                                <td>{tipoDespesasVendedor.name}</td>
                                                <td>{tipoDespesasVendedor.icon}</td>
                                                <td>
                                                    {userPermissions.includes(3) && (
                                                        <Button onClick={() => { handleEditTipoDespesasVendedor(tipoDespesasVendedor) }}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                    )}
                                                    {userPermissions.includes(4) && (
                                                        <Button onClick={() => handleDeleteTipoDespesasVendedor(tipoDespesasVendedor.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                            <div className="d-flex justify-content-end mt-3">
                                {tipoDespesasVendedorPageCount && (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={tipoDespesasVendedorPageCount}
                                        />
                                    </div>
                                )}
                                {listTipoDespesasVendedor.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar os tipos de depesa.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <CreateTipoDespesasVendedorModal
                isOpen={createModalOpen}
                toggle={() => setCreateModalOpen(false)}
                onCreated={() => getAllTipoDespesasVendedorPaged(1, 9, objUserTk.EmpresaId)}
            />

            <EditTipoDespesasVendedorModal
                isOpen={editModalOpen}
                toggle={() => setEditModalOpen(false)}
                tipoDespesasVendedor={editingTipoDespesasVendedor}
                onUpdated={() => getAllTipoDespesasVendedorPaged(1, 9, objUserTk.EmpresaId)}
            />
        </>
    );
};

export default ContaPagar;